import { render, staticRenderFns } from "./Exception04.vue?vue&type=template&id=6401400e&scoped=true&"
import script from "./Exception04.vue?vue&type=script&lang=js&"
export * from "./Exception04.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6401400e",
  null
  
)

export default component.exports